export const nestedProp = (object, nestedRoute) => {
  const reducer = (obj, prop) => {
    return typeof obj === 'undefined' || obj === null ? obj : obj[prop];
  };
  return nestedRoute.split('.').reduce(reducer, object);
};
